export const router = [
  {
    path: '/docusign-success',
    name: 'docusign-success',
    component: () => import('/@/modules/guidancestep/pages/DocuSignSuccessPage.vue'),
    meta: { authOnly: false }
  }
];
